export const company = {
  name: "vCX",
  uuid: "53d1bcd3-aaf0-45e1-9298-5395b6a27b61",
  logo: "https://example.com/logo.png",
  chatApi: "https://chatbackenddev.versal.one/",
};

export const api = {
  baseUrl: "https://customer.versalence.info/customer",
  companyId: "VERSP001812025",
  authToken: process.env.REACT_APP_AUTH_TOKEN || "",
  razorpayKey: "rzp_live_RrogpQi8QwEnmL",
};

export const postiz = {
  apiUrl: process.env.REACT_APP_POSTIZ_API_URL || "http://localhost:3000",
  uploadBackendUrl: process.env.REACT_APP_INFINIUM_BACKEND || "http://localhost:5001",
};

export const apiEndpoints = {
  addCustomer: `/add-ExternalUser/${api.companyId}`,
  sendVerification: `/send-verification/${api.companyId}`,
  verifyEmail: `/verify-email/${api.companyId}`,
  customerLogin: `/customer-login`,
  sendLoginOtp: `/send-login-otp`,
  sendEmail: `/send-email`,
  loginWithOtp: `/login-with-otp`,
  forgotPassword: `/forgot-password`,
  verifyResetOtp: `/verify-reset-otp`,
  resetPassword: `/reset-password`,
  profile: `/profile`,
  changePassword: `/change-password`,
  monthlyUsage: `/usage/monthly`,
  credits: `/credits`,
  deductChat: `/usage/chat`,
  trackingFile: `/tracking/file`,
  createOrder: `/payments/create-order`,
  verifyPayment: `/payments/verify-payment`,
  paymentHistory: `/payments/history`,
  getInfiniumPlans: '/getInfiniumPlans',
  assignUser: '/assign-user',
  activeSubscription: '/subscription/active',
  renewSubscription: '/payments/renew',
  proratedPayment: '/payments/prorated',
};

export const botpress = {
  apiUrl: "https://api.botpress.cloud/v1",
  token: process.env.REACT_APP_BOTPRESS_TOKEN || "",
  botId: "f7de63d1-238f-4551-9541-e0dd6c96fdca",
};
